import { __assign, __awaiter, __generator } from "tslib";
import { useState, useEffect } from 'react';
import { middlewareClientExecutor } from '../../utils/middleware-executor';
import { useClientEnv } from '../config';
import { useRouter } from '../router';
var useClientMiddlewares = function (_a) {
    var _b;
    var middlewares = _a.middlewares;
    var _c = useState({}), data = _c[0], setData = _c[1];
    var route = useRouter();
    var client = useClientEnv().client;
    var clientProps = middlewares.clientProps, middlewaresArgs = middlewares.middlewaresArgs, clientSideBeforeFetchMiddlewares = middlewares.clientSideBeforeFetchMiddlewares, clientSideAfterFetchMiddlewares = middlewares.clientSideAfterFetchMiddlewares;
    /**
     * here we run all middlewares because this hook
     * just will be used when the page does not has graphql query
     */
    var allMiddlewares = clientSideBeforeFetchMiddlewares.concat(clientSideAfterFetchMiddlewares);
    useEffect(function () {
        // https://nextjs.org/docs/pages/building-your-application/rendering/automatic-static-optimization#how-it-works
        if (route.isReady) {
            var routeInfo_1 = __assign(__assign({}, (clientProps['route'] || {})), { deviceInfo: route.deviceInfo, query: route.query });
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var parsedData, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, 4, 5]);
                            route.setDataLoading(true);
                            if (!allMiddlewares.length) return [3 /*break*/, 2];
                            return [4 /*yield*/, middlewareClientExecutor(allMiddlewares, __assign(__assign({}, clientProps), { clientConfig: client, route: routeInfo_1 }), middlewaresArgs)];
                        case 1:
                            parsedData = _a.sent();
                            setData(parsedData);
                            _a.label = 2;
                        case 2: return [3 /*break*/, 5];
                        case 3:
                            err_1 = _a.sent();
                            console.error('[RaveJS] - Error executing middlewares', err_1);
                            throw err_1;
                        case 4:
                            route.setDataLoading(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [route.isReady, JSON.stringify(route.query), (_b = route.asPath) === null || _b === void 0 ? void 0 : _b.split('#')[0]]);
    return { data: data };
};
export default useClientMiddlewares;
//# sourceMappingURL=useClientMiddlewares.js.map